/**
 * add index, iteratorId from state to proxy.
 * @param {Object} proxy proxy value need append
 * @param {State} state which get value from
 */
export default function proxyIndex(proxy, state) {
  let $iteratorId;
  let $index;
  // use getValue to not cause report as observed
  if (state && typeof state.getIteratorId === 'function') {
    $iteratorId = state.getIteratorId() || state.getValue('$iteratorId');
  }
  if (state && typeof state.getIndex === 'function') {
    $index = state.getIndex() || state.getValue('$index');
  }
  if ($index !== undefined) {
    proxy.index = $index;
  }
  if ($iteratorId !== undefined) {
    proxy.iteratorId = $iteratorId;
  }
}
